var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.437,
    height: 5.031,
    viewBox: "0 0 9.437 5.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11086",
    "data-name": "Group 11086",
    transform: "translate(0.706 0.706)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_627",
    "data-name": "Line 627",
    x2: 4.012,
    y2: 3.618,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_628",
    "data-name": "Line 628",
    x1: 4.012,
    y2: 3.618,
    transform: "translate(4.012)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.fe1cfbed76b5bf2b1ba3c54e7801bbb2.svg";
export { ForwardRef as ReactComponent };